module.exports = __webpack_public_path__ + "img/conference.ad3740ea.png";